import React, { createContext, useContext, useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  useParams,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "./Components/i18n";
import "./App.css";

import Layout from "./Components/Layout";
import Home from "./Pages/Home";
import ProductDetail from "./Pages/ProductDetail";
import ProductNew from "./Pages/ProductNew";

import Cart from "./Pages/Cart";
import Sign_in from "./Pages/Sign_in";
import Sign_up from "./Pages/Sign_up";

import Page from "./Pages/Page";
import Search from "./Pages/Search";
import Dashboard from "./Pages/Dashboard";
import axios from "axios";
import ProductComparison from "./Pages/Comparison";
import PaymentResultRoute from "./Components/PaymentResultRoute";
import SearchResult from "./Pages/SearchResult";
import CreditPayment from "./Pages/CreditPayment";
import Contact from "./Pages/Contact";
import Qanunvericilik from "./Pages/Qanunvericilik";
import MxfilikSiyaseti from "./Pages/MxfilikSiyaseti";
import SaytdanIstifadeSertleri from "./Pages/SaytdanIstifadeSertleri";
import MenuPage from "./Pages/MenuPage";
import CompleteOrder from "./Pages/CompleteOrder";
import ConfirmCart from "./Pages/ConfirmCart";
import Profile from "./Pages/Profile";
import MonthlyPayment from "./Components/MonthlyPayment";
import Business from "./Pages/Business";
import NotFound from "./Pages/NotFound";
import RouteValidator from "./Components/RouteValidator";
import {
  AYLIK_ODENIS_ENABLED,
  CREDIT_PAYMENT_ENABLED,
  TEST_PAYMENT_PAGE_ENABLED,
  TEST_PAYMENT_PATH_SEGMENT,
} from "./constants";
import TestPaymentGatewayPage from "./Pages/TestPaymentGatewayPage";
import TemporarilyUnavailable from "./Pages/TemporarilyUnavailable";

const AuthContext = createContext({
  user: null,
  token: null,
  setUser: () => {},
  setToken: () => {},
});

function AylikOdenisRoute() {
  const { lang } = useParams();
  if (!AYLIK_ODENIS_ENABLED) {
    return <Navigate to={lang ? `/${lang}/` : "/"} replace />;
  }
  // Header açır modalı və URL-i əsas səhifəyə replace edir
  return <Navigate to={lang ? `/${lang}/` : "/"} replace />;
}

function CreditPaymentRoute() {
  if (!CREDIT_PAYMENT_ENABLED) {
    return <TemporarilyUnavailable />;
  }
  return <CreditPayment />;
}

function TestPaymentRoute() {
  if (!TEST_PAYMENT_PAGE_ENABLED) {
    return <NotFound />;
  }
  return <TestPaymentGatewayPage />;
}

function App() {
  const { i18n } = useTranslation();
  const url = window.location.pathname;
  const segments = url.split("/");

  useEffect(() => {
    const lang = segments[1];
    i18n.changeLanguage(lang || "az");
  }, []);


  return (
    <>
      <BrowserRouter>
        {/* <AuthProvider> */}
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path=":lang/product/:id" element={<RouteValidator><ProductDetail /></RouteValidator>} />
              <Route path=":lang/productnew/" element={<RouteValidator><ProductNew /></RouteValidator>} />

              <Route path=":lang/aylik-odenis/" element={<RouteValidator><AylikOdenisRoute /></RouteValidator>} />
              <Route path=":lang/business/" element={<RouteValidator><Business /></RouteValidator>} />

              <Route path=":lang/menu-page/:id" element={<RouteValidator><MenuPage /></RouteValidator>} />
              <Route path="/payment-result" element={<PaymentResultRoute />} />
              <Route path=":lang/searchResult/:storeSlug?&&:userCode?&&:initialPageIndex?&&:keyWord?&&:categoryId?&&:sortType?" element={<RouteValidator><SearchResult /></RouteValidator>} />
              <Route path=":lang/credit-payment" element={<RouteValidator><CreditPaymentRoute /></RouteValidator>} />
              <Route path=":lang/comparison" element={<RouteValidator><ProductComparison /></RouteValidator>} />
              <Route path=":lang/contact" element={<RouteValidator><Contact /></RouteValidator>} />
              <Route path=":lang/qanunvericilik" element={<RouteValidator><Qanunvericilik /></RouteValidator>} />
              <Route path=":lang/mxfilik-siyaseti" element={<RouteValidator><MxfilikSiyaseti /></RouteValidator>} />
              <Route path=":lang/saytdan-istifade-sertleri" element={<RouteValidator><SaytdanIstifadeSertleri /></RouteValidator>} />
              <Route path=":lang/cart" element={<RouteValidator><Cart /></RouteValidator>} />
              <Route path=":lang/cart/confirm-cart" element={<RouteValidator><ConfirmCart /></RouteValidator>} />
              <Route path=":lang/cart/:id" element={<RouteValidator><CompleteOrder /></RouteValidator>} />
              <Route path=":lang/sign_in" element={<RouteValidator><Sign_in /></RouteValidator>} />
              <Route path=":lang/sign_up" element={<RouteValidator><Sign_up /></RouteValidator>} />
              <Route path=":lang/profile" element={<RouteValidator><Profile /></RouteValidator>} />
              <Route
                path={`:lang/${TEST_PAYMENT_PATH_SEGMENT}`}
                element={
                  <RouteValidator>
                    <TestPaymentRoute />
                  </RouteValidator>
                }
              />
              {/* <Route element={<ProtectedRoute />}>
                <Route path=":lang/dashboard" element={<Dashboard />} />
              </Route> */}

              <Route path=":lang/Page" element={<RouteValidator><Page /></RouteValidator>} />
              <Route path=":lang/Search" element={<RouteValidator><Search /></RouteValidator>} />
              {/* Home route - must be after all other :lang routes to avoid conflicts */}
              <Route path=":lang" element={<RouteValidator isHomeRoute={true}><Home /></RouteValidator>} />
              {/* Catch invalid paths after language (like /ru/gayfdsfa) */}
              <Route path=":lang/*" element={<NotFound />} />
            </Route>
            {/* Catch-all route for 404 - outside Layout to catch all unmatched routes */}
            <Route path="*" element={<Layout><NotFound /></Layout>} />
          </Routes>
        {/* </AuthProvider> */}
      </BrowserRouter>
    </>
  );
}

export const useStateContext = () => useContext(AuthContext);

export default App;
